import extractErrorMessage from '../../../shared/utils/extractErrorMessage';
import { authClient } from '../../../shared/api/client';

const isOkStatus = (status) => status >= 200 && status < 300;

// Sve rute su samo za super admina.
export const fetchAdmins = async () => {
  try {
    const response = await authClient.get('/admins');
    return {
      data: Array.isArray(response.data?.admins) ? response.data.admins : [],
      status: response.status,
      ok: isOkStatus(response.status),
      message: response.data?.message || null,
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dobavljanju admina.'
    );
    return {
      data: null,
      status: error?.response?.status || null,
      ok: false,
      message,
    };
  }
};

export const createAdmin = async ({
  firstName,
  lastName,
  username,
  email,
  pin,
}) => {
  try {
    const response = await authClient.post('/admins', {
      firstName,
      lastName,
      username,
      email,
      pin,
    });
    return {
      data: response.data?.admin || null,
      status: response.status,
      ok: isOkStatus(response.status),
      message: response.data?.message || 'Admin je dodat.',
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dodavanju admina.'
    );
    return {
      data: null,
      status: error?.response?.status || null,
      ok: false,
      message,
    };
  }
};

export const resetAdminPin = async (id, pin) => {
  try {
    const response = await authClient.put(`/admins/${id}/pin`, { pin });
    return {
      data: response.data?.admin || null,
      status: response.status,
      ok: isOkStatus(response.status),
      message: response.data?.message || 'PIN admina je resetovan.',
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri resetovanju PIN-a.'
    );
    return {
      data: null,
      status: error?.response?.status || null,
      ok: false,
      message,
    };
  }
};

export const deleteAdmin = async (id) => {
  try {
    const response = await authClient.delete(`/admins/${id}`);
    return {
      data: response.data,
      status: response.status,
      ok: isOkStatus(response.status),
      message: response.data?.message || 'Admin je obrisan.',
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri brisanju admina.'
    );
    return {
      data: null,
      status: error?.response?.status || null,
      ok: false,
      message,
    };
  }
};
